// extracted by mini-css-extract-plugin
export var actionText = "_q2-4";
export var container = "_q2-0";
export var leftSection = "_q2-1";
export var rightSection = "_q2-2";
export var settingsButton = "_q2-6";
export var settingsIcon = "_q2-7";
export var shortcut = "_q2-5";
export var shortcutGroup = "_q2-3";